var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGocciaRiflesso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.68,20.68L250,0l-20.68,20.68c-6.7,6.7-161.82,163.63-161.82,296.84,0,100.78,81.71,182.48,182.5,182.48s182.5-81.7,182.5-182.48c0-132.61-155.12-290.15-161.82-296.84ZM251.49,439.16c-.5.01-.99.01-1.49,0-67.11-.19-121.47-54.54-121.67-121.64-.17-16.63,13.17-30.25,29.8-30.42.2,0,.41,0,.62,0,16.63-.17,30.25,13.17,30.42,29.8v.62c.1,33.55,27.27,60.72,60.83,60.82,16.8-.41,30.75,12.87,31.16,29.67.41,16.8-12.87,30.74-29.67,31.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGocciaRiflesso);
export default __webpack_public_path__ + "static/media/goccia_riflesso.6004adfe230403cbeefe23ff05718cd4.svg";
export { ForwardRef as ReactComponent };